"use client"

// Simple toast implementation
export function toast({ title, description, variant = "default" }) {
  // In a real app, you would use a proper toast library
  // This is a simple implementation for demonstration

  const toastStyle = {
    position: "fixed",
    bottom: "20px",
    right: "20px",
    padding: "10px 20px",
    borderRadius: "4px",
    backgroundColor: variant === "destructive" ? "#f44336" : "#4caf50",
    color: "white",
    boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
    zIndex: 9999,
    maxWidth: "300px",
  }

  // Create toast element
  const toastElement = document.createElement("div")
  toastElement.style.position = toastStyle.position
  toastElement.style.bottom = toastStyle.bottom
  toastElement.style.right = toastStyle.right
  toastElement.style.padding = toastStyle.padding
  toastElement.style.borderRadius = toastStyle.borderRadius
  toastElement.style.backgroundColor = toastStyle.backgroundColor
  toastElement.style.color = toastStyle.color
  toastElement.style.boxShadow = toastStyle.boxShadow
  toastElement.style.zIndex = toastStyle.zIndex
  toastElement.style.maxWidth = toastStyle.maxWidth

  // Add title and description
  const titleElement = document.createElement("div")
  titleElement.style.fontWeight = "bold"
  titleElement.textContent = title

  const descElement = document.createElement("div")
  descElement.textContent = description

  toastElement.appendChild(titleElement)
  toastElement.appendChild(descElement)

  // Add to document
  document.body.appendChild(toastElement)

  // Remove after 3 seconds
  setTimeout(() => {
    toastElement.style.opacity = "0"
    toastElement.style.transition = "opacity 0.5s"
    setTimeout(() => {
      document.body.removeChild(toastElement)
    }, 500)
  }, 3000)
}
